<template>
  <div id="q-app">
    <SideMenu />
    <GameRulesModal />
    <PrivacyPolicyModal />
    <SuggestionModal />
    <DonationModal />
    <LandingScreen />
    <QuestionTypeSelection />
    <QuestionDisplay />
    <ToastNotification />
  </div>
</template>

<script>
import { useStore } from '../store';
import { onMounted } from 'vue';
import SideMenu from './SideMenu.vue';
import GameRulesModal from './GameRulesModal.vue';
import PrivacyPolicyModal from './PrivacyPolicyModal.vue';
import SuggestionModal from './SuggestionModal.vue';
import DonationModal from './DonationModal.vue';
import LandingScreen from './LandingScreen.vue';
import QuestionTypeSelection from './QuestionTypeSelection.vue';
import QuestionDisplay from './QuestionDisplay.vue';
import ToastNotification from './ToastNotification.vue';

export default {
  name: 'Question',
  components: {
    SideMenu,
    GameRulesModal,
    PrivacyPolicyModal,
    SuggestionModal,
    DonationModal,
    LandingScreen,
    QuestionTypeSelection,
    QuestionDisplay,
    ToastNotification,
  },
  setup() {
    const store = useStore();
    onMounted(() => {
      store.initialize();
    });
  },
};
</script>
